import { getType } from 'typesafe-actions';
import { actions } from '..';
import { QueueEmail, AccountType } from '../../model';
import { Actions, StoreState } from '../types';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

type EmailDetails = QueueEmail[] | null

export function queueMyEmails(state: EmailDetails = null, action: Actions): EmailDetails {
  switch (action.type) {
    case (getType(actions.fetchMyQueueEmails.request)):
      return []
    case (getType(actions.fetchMyQueueEmails.response)):
      return action.payload
  }

  return state
}

export function queueEmails(state: EmailDetails = null, action: Actions): EmailDetails {
  switch (action.type) {
    case (getType(actions.fetchQueueEmails.request)):
      return []
    case (getType(actions.fetchQueueEmails.response)):
      return action.payload
  }

  return state
}

export default combineReducers({
  queueMyEmails,
  queueEmails,
})

function getRoot(state: StoreState) { return state.queueEmails }

export function getMyQueueEmails(state: StoreState) {
  return getRoot(state).queueMyEmails
}
export function getQueueEmails(state: StoreState) {
  return getRoot(state).queueEmails
}

export const shouldFetchMyQueueEmails = (state: StoreState) => getMyQueueEmails(state) === null
export const shouldFetchQueueEmails = (state: StoreState) => getQueueEmails(state) === null

export const selectMyQueueEmails = createSelector(
  getMyQueueEmails,
  (emails) => {
    if (!emails) return emails

    return emails.filter(x => x.enabled)
  },
)

export const selectEmailAccount = createSelector(
  getQueueEmails,
  (_s: StoreState, accountId: string) => accountId,
  (emails, accountId) => {
    if (!emails) return undefined

    return emails.find(x => x.accountId === accountId)
  },
)

export const selectAdvancedSearchQueueEmails = createSelector(
  getQueueEmails,
  (emails) => {
    if (!emails) return emails

    const z = emails.filter(x => x.enabled || (!x.enabled && x.azureSearchEnabled))
    z.push({
      accountId: '',
      queueId: '',
      queueDescription: '',
      signatureTemplatePath: '',
      enabled: true,
      defaultEmailFontFamily: '',
      emailAddress: 'Select email account',
      accountType: AccountType.Ews,
      azureSearchEnabled: true,
      azureSearchGroup: 'Select email account',
    })
    const y = z.sort((a, b) => {
      if (a.azureSearchGroup === 'Select email account') {
        return -1
      } if (b.azureSearchGroup === 'Select email account') {
        return 1
      } else {
        return a.emailAddress > b.emailAddress ? 1 : -1
      }
    })
    return y
  },
)

export const selectAdvancedSearchGroups = createSelector(
  getQueueEmails,
  (emails) => {
    if (!emails) return emails
    const z = emails.filter(x => x.enabled || (!x.enabled && x.azureSearchEnabled))
    const x = getUniqueArray(z).filter(x => x.azureSearchGroup !== '')
    x.push({
      accountId: '',
      queueId: '',
      queueDescription: '',
      signatureTemplatePath: '',
      enabled: true,
      defaultEmailFontFamily: '',
      emailAddress: 'Select email group',
      accountType: AccountType.Ews,
      azureSearchEnabled: true,
      azureSearchGroup: 'Select email group',
    })
    const y = x.sort((a, b) => {
      if (a.azureSearchGroup === 'Select email group') {
        return -1
      } if (b.azureSearchGroup === 'Select email group') {
        return 1
      } else {
        return a.azureSearchGroup > b.azureSearchGroup ? 1 : -1
      }
    })

    return y
  },
)

export const selectSearchEmailAccounts = createSelector(
  getQueueEmails,
  (emails) => {
    if (!emails) return emails
    const all = emails.filter(x => x.enabled || (!x.enabled && x.azureSearchEnabled)).sort((a, b) => a.emailAddress > b.emailAddress ? 1 : -1).map(m => {
      return { ...m, type: 0 }
    })
    const groups = getUniqueArray(all).filter(x => x.azureSearchGroup !== '').sort((a, b) => a.azureSearchGroup > b.azureSearchGroup ? 1 : -1).map(m => {
      return { ...m, type: 1 }
    })

    return groups.concat(all)
  },
)

function getUniqueArray(array: QueueEmail[]) {
  let uniqueArray = [];
  if (array.length > 0) {
    uniqueArray[0] = array[0];
  }
  for (let i = 0; i < array.length; i++) {
    let isExist = false;
    for (let j = 0; j < uniqueArray.length; j++) {
      if (array[i].azureSearchGroup === uniqueArray[j].azureSearchGroup) {
        isExist = true;
        break;
      }
      else {
        isExist = false;
      }
    }
    if (isExist === false) {
      uniqueArray[uniqueArray.length] = array[i];
    }
  }
  return uniqueArray;
}
